export default "__VITE_ASSET__BSjoZb8Z__"